import mqtt from "mqtt/dist/mqtt";
import moment from "moment-timezone";

const state = () => ({
    higienizacion1: {
        temperaturaUmbral: 85,
        tiempoUmbral: 902, //En segundos
    },
    previos_horno:{},
    higienizacion2: {
        temperaturaUmbral: 90,
        tiempoUmbral: 600, //En segundos
    },
    tiempoFalloHigienizacion1: 0, //En segundos
    tiempoFalloHigienizacion2: 0, //En segundos
    usuarioLogeado: null, //Por seguridad solo el nombre
    cicloDia: 1,
    horaCicloAnterior: '',
});

const getters = {
    getHornoPrevios(state){
        return state.previos_horno
    }
};

const mutations = {
  
};

const actions = {
    set_previos_horno({state},payload){
        // console.log(payload);
        try {
          state.previos_horno =  JSON.parse(payload)
        } catch (error) {
          console.log(error);
          state.previos_horno = {}
        } finally {
          console.log(state.previos_horno);
        }
      },

    //SOLO PARA PINTAR EN EL FRONTEND
    set_temp_umbral_hig1({commit,state},payload){
    state.higienizacion1.temperaturaUmbral = payload
    },
    set_temp_umbral_hig2({commit,state},payload){
    state.higienizacion2.temperaturaUmbral = payload
    },
    set_tiempo_umbral_hig1({commit,state},payload){
    state.higienizacion1.tiempoUmbral = payload
    },
    set_tiempo_umbral_hig2({commit,state},payload){
    state.higienizacion2.tiempoUmbral = payload
    },

    
    set_fallo_hignienizacion1({commit}){ //Tiempo total, no secesariamente continuo
    this.tiempoFalloHigienizacion1++
    },
    set_fallo_hignienizacion2({commit}){ //Tiempo total, no secesariamente continuo
    this.tiempoFalloHigienizacion2++
    },

    set_usuarioLogeado({commit,state},payload){
    state.usuarioLogeado = payload
    },

    set_cicloDia({commit,state},payload){
    state.cicloDia = payload
    },
    set_horaCicloAnterior({commit,state},payload){
    state.horaCicloAnterior = payload
    },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
